import {searcher, eraser} from './restClient.js';
import {createForm, fetchOne, createAlert, removeAlerts} from './commonUI.js';

/**
 * enhanced html5 form
 * @return {HTMLFormElement}
 */
export const createLijstForm = () => {
    const form = createForm(); // extended HTMLFormElement class
    form.setAttribute('aria-label','search');
    let el; // pas through HTMLElement container
    // Fieldset data
    el = form.appendChild(document.createElement('fieldset'));
    el.appendChild(document.createElement('legend')).innerHTML = 'Go get \'em';
    // el.appendChild(document.createElement('div'));
    form.create_input('zoekterm', {parentNode: el});
    form.querySelector('label').classList.add('bi', 'bi-search');
    // el = el.insertAdjacentElement("afterend", document.createElement('div'));
    form.create_button('zoek', {parentNode: el, theme: 'btn-primary'}); // .setAttribute('type', 'submit'); // implicit in html5
    return form;
}
/**
 * fetch search and fill #lijst
 * @param lijst
 * @param query
 * @return {Promise<void>}
 */
const search = async (lijst, query = '') => {
    removeAlerts();
    try {
        const result = await searcher(dataUrl, query);
        console.group('gevonden'); console.log(result); console.groupEnd();
        lijst.empty();
        await Promise.all([...result].map(r => lijst.addFillRow(r)));
        if (result.at(0)?._links.self.href) {
            const url = result.at(0)._links.self.href;
            await fetchOne(url);
        }
    } catch (e) {
        if (e?.cause === 404) lijst.insertAdjacentElement('beforebegin', createAlert('None Found!\nTry something else then &ldquo;'+query+'&rdquo; .\nBetter luck next time?'));
        console.error(new URL('?zoek='+query,dataUrl)+' not delivering?'+'\n'+e.message); console.trace(e);
        lijst.empty();
    }
    return Promise.resolve();
}
/**
 * Add controls to #lijst
 * @param lijst our table
 */
export const addTableElementListeners = (lijst) => {
    lijst.addEventListener('click', async (e) => {
        // remove any if exists
        removeAlerts();
        // delete (Sorry just for the fun of it - a back-up)
        let source = e?.target;
        if (source?.nodeName === 'I' && source.classList.contains('bi-trash')) {
            console.error('Hey Css didn\'t do the trick?'); // just in case the css won't work (i.e Overkill!)
            // e.target.parentElement.dispatchEvent(new Event('click')); // we could't dispatch as there is no listener on the button parent
            source = source.parentElement;
        }
        if (source?.nodeName === 'BUTTON' && source?.firstElementChild.classList.contains('bi-trash')) {
            console.log('deleting...' + source.parentNode.parentNode.firstElementChild.dataset.location);
            if (await eraser(source.parentNode.parentNode.firstElementChild.dataset.location).catch(e => {
                console.error('No '+source.title+'\n' + e.message); console.trace(e);
                lijst.insertAdjacentElement('beforebegin', createAlert('Foutcode: '+ (e.cause??"Niet gekend") +'\n'+'We geraken er niet van af!'));
            })) source.parentNode.parentNode.remove();
            e.stopPropagation();
        }
        // edit
        if (source?.nodeName === 'TD') {
            console.log('showing...' + source.parentNode.childNodes[1].firstChild.textContent);
            try {
                await fetchOne(source.parentNode.firstElementChild.dataset.location);
                bootstrap.Tab.getInstance(document.querySelector('nav a[data-bs-target="#detail"]')).show();
                document.getElementById('f_zoek').value = '';
            } catch (e) {
                lijst.insertAdjacentElement('beforebegin', createAlert(((e?.cause === 404) ? 'Not Found! \n':'')+'This should not have happened!'));
                document.getElementById('detail').firstElementChild.nextElementSibling.empty();
            }
        }
        e.stopPropagation();
    });
    // search
    lijst.parentElement.previousElementSibling.elements.namedItem('zoekterm').addEventListener('focus', () => removeAlerts());
    lijst.parentElement.previousElementSibling.addEventListener('submit', (e)=>{
        e.preventDefault();
        search(lijst, lijst.parentElement.previousElementSibling.elements.namedItem('zoekterm').value).catch(e=>console.error(e));
        e.stopPropagation();
    });
};
